import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import { m } from '../../utils';
import './index.css';
import Loading from '../shared/Loading';
import BookingHeader from './BookingHeader';
import BookingFilter from './BookingFilter';
import BookingCalendarQuery from './BookingCalendarQuery';
import BookingReview from './BookingReview';
import BookingConfirmation from './BookingConfirmation';
import BookingComplete from './BookingComplete';
import Divider from '../../artzu-ui/src/Divider';
import Modal from '../../artzu-ui/src/Modal';
import Button from '../../artzu-ui/src/Button';
import Icon from '../../artzu-ui/src/Icon';
import BankingModal from './BankingModal';
import BookingFooter from './BookingFooter';

const plusImg =
  'https://s3.us-east-2.amazonaws.com/autzu-team/cars/photos/Dodge+Angled+View+cropped.png';
class MobileBook extends Component {
  constructor(props) {
    super(props);
    this.state = {
      parkinglotId: null,
      parkinglotName: null,
      shifts: [3, 7, 11, 15, 19, 23],
      flow: ['filter', 'calendar', 'review', 'confirmation', 'complete'],
      shiftStart: null,
      shiftEnd: null,
      duration: null,
      tier: null,
      rate: { pro: 6.75, plus: 4.75, go: 8.25 },
      flexible: null,
      selectedShifts: [],
      display: 'filter',
      confirmation: null,
      showModal: false,
      showPlusInfo: false,
      invalidFields: [],
      pendingBooking: false,
      showUnavailable: false,
      unavailableMessage: null
    };
  }

  render() {
    const {
      shifts,
      parkinglotId,
      parkinglotName,
      shiftStart,
      shiftEnd,
      duration,
      tier,
      rate,
      flexible,
      selectedShifts,
      display,
      confirmation,
      invalidFields,
      pendingBooking,
      hideOrientation
    } = this.state;

    return (
      <Query
        query={gql`
          query currentUser {
            currentUser {
              id
              status
              email
              uberToken
              certification
              hoursThisWeek
              bookingsThisWeek
              newBookingOrientation
              accessibleVehicleClasses
              parkinglots {
                id
                city
                region
                mapUrl
                address {
                  streetAddress
                  postalCode
                  province
                  city
                }
              }
              accountNumber
              institutionNumber
              transitNumber
              uberToken
              operatingCity
            }
          }
        `}>
        {({ loading, error, data, refetch }) => {
          if (loading) {
            return (
              <div className="load-div">
                <Loading size="3x" />
              </div>
            );
          }
          if (error) {
            return <Redirect to="/404" />;
          }
          if (display === 'dashboard') return <Redirect to="/dashboard" />;
          const {
            accountNumber,
            transitNumber,
            institutionNumber,
            uberToken,
            operatingCity,
            accessibleVehicleClasses
          } = data.currentUser;
          if (!parkinglotId) {
            this.selectParkinglot(
              parseInt(data.currentUser.parkinglots[0].id),
              data.currentUser.parkinglots[0].region
            );
          }
          if (!tier) {
            this.selectTier(accessibleVehicleClasses[0]);
          }
          return window.innerWidth < 768 ? (
            <Redirect to="/downloadapp" />
          ) : (
            <div className="booking-mobile">
              <BankingModal
                open={
                  operatingCity === 'toronto' &&
                  !(accountNumber && transitNumber && institutionNumber) &&
                  uberToken
                }
              />
              <BookingHeader
                display={display}
                heading={this.formatHeading()}
                shiftStart={shiftStart}
                shiftEnd={shiftEnd}
                tier={tier}
                flexible={flexible}
                selectedShifts={selectedShifts}
                editFilter={this.editFilter}
                backAction={this.backAction}
                formatShift={this.formatShift}
                showModal={this.showModal}
              />
              <Divider fullwidth />
              {display === 'filter' || display === 'editFilter' ? (
                <BookingFilter
                  parkinglotId={parkinglotId}
                  tier={tier}
                  shiftStart={shiftStart}
                  shiftEnd={shiftEnd}
                  flexible={flexible}
                  selectParkinglot={this.selectParkinglot}
                  selectTier={this.selectTier}
                  selectShiftStart={this.selectShiftStart}
                  selectShiftEnd={this.selectShiftEnd}
                  selectFlexibility={this.selectFlexibility}
                  formatShift={this.formatShift}
                  invalidFields={invalidFields}
                  certification={data.currentUser.certification}
                  bookModal={this.bookModal}
                  showPlusInfo={this.showPlusInfo}
                  plusInfo={this.plusInfo}
                  display={display}
                  showModal={this.showModal}
                  accessibleVehicleClasses={
                    data.currentUser.accessibleVehicleClasses
                  }
                  parkinglots={data.currentUser.parkinglots}
                  shifts={shifts}
                  resetShiftParams={this.resetShiftParams}
                />
              ) : null}
              {display === 'calendar' ? (
                <BookingCalendarQuery
                  className="calendar-wrapper"
                  shifts={shifts}
                  parkinglotId={parkinglotId}
                  shiftStart={shiftStart}
                  shiftEnd={shiftEnd}
                  tier={tier}
                  flexible={flexible}
                  selectedShifts={selectedShifts}
                  addShiftToSelection={this.addShiftToSelection}
                  rate={rate}
                  bookModal={this.bookModal}
                  formatShift={this.formatShift}
                  unavailableModal={this.unavailableModal}
                  showUnavailableModal={this.showUnavailableModal}
                  newBookingOrientation={
                    data.currentUser.newBookingOrientation
                  }
                  handleHideOrientation={this.handleHideOrientation}
                  hideOrientation={hideOrientation}
                />
              ) : null}
              {display === 'review' ? (
                <BookingReview
                  selectedShifts={selectedShifts}
                  parkinglotName={parkinglotName}
                  tier={tier}
                  removeShiftFromSelection={this.addShiftToSelection}
                  rate={rate}
                />
              ) : null}
              {pendingBooking ? (
                <div className="load-div">
                  <Loading size="3x" />
                </div>
              ) : null}
              {display === 'confirmation' ? (
                <BookingConfirmation
                  confirmation={confirmation}
                  parkinglotName={this.state.parkinglotName}
                />
              ) : null}
              {display === 'complete' ? (
                <BookingComplete renderComplete={this.renderComplete} />
              ) : null}
              {/* <Divider fullwidth className="foot-divider" /> */}

              <BookingFooter
                display={display}
                promoProgress={data.currentUser.bookingsThisWeek}
                duration={duration}
                selectedShifts={selectedShifts}
                footerButton={this.assignButtonName()}
                submitAction={this.assignButtonAction}
                resetParams={this.resetParams}
                receiveConfirmation={this.receiveConfirmation}
                showModal={this.showModal}
                pendBooking={this.pendBooking}
                media="mobile"
              />
            </div>
          );
        }}
      </Query>
    );
  }

  selectParkinglot = (parkinglotId, parkinglotName) => {
    this.setState({ parkinglotId, parkinglotName });
  };

  selectTier = tier => {
    this.setState({ tier });
  };

  selectShiftStart = shiftStart => {
    const { shiftEnd } = this.state;
    shiftStart = parseInt(shiftStart, 10);
    this.setState({
      shiftStart: parseInt(shiftStart, 10),
      duration: shiftEnd
        ? shiftEnd <= shiftStart
          ? shiftEnd + 24 - shiftStart
          : shiftEnd - shiftStart
        : null
    });
  };

  selectShiftEnd = shiftEnd => {
    const { shiftStart } = this.state;
    shiftEnd = parseInt(shiftEnd, 10);
    this.setState({
      shiftEnd: parseInt(shiftEnd, 10),
      duration: shiftStart
        ? shiftEnd <= shiftStart
          ? shiftEnd + 24 - shiftStart
          : shiftEnd - shiftStart
        : null
    });
  };

  resetShiftParams = () => {
    this.setState({ shiftStart: null, shiftEnd: null, duration: null });
  };

  selectFlexibility = flexible => {
    this.setState({ flexible });
  };

  editFilter = () => {
    this.setState({
      display: 'editFilter'
    });
  };

  addShiftToSelection = (
    date,
    startTime,
    endTime,
    vehicleClass,
    rate,
    shiftRates,
    parkinglotId
  ) => {
    const { selectedShifts } = this.state;
    const booking = {
      vehicleClass,
      date,
      startTime,
      endTime: endTime < startTime ? endTime.add(1, 'day') : endTime,
      rate,
      shiftRates,
      parkinglotId
    };
    if (
      selectedShifts.find(shift =>
        shift.startTime.isSame(booking.startTime)
      )
    ) {
      const remaining = selectedShifts.filter(
        shift => !shift.startTime.isSame(booking.startTime)
      );
      this.setState({
        selectedShifts: remaining
      });
    } else {
      this.setState({
        selectedShifts: [...this.state.selectedShifts, booking]
      });
    }
  };

  loadSelectionOntoFooter = selectedShifts => selectedShifts;

  assignButtonName = () => {
    const { display, selectedShifts } = this.state;
    let name;
    switch (display) {
      case 'filter':
        name = 'Search';
        break;
      case 'editFilter':
        name = 'Update';
        break;
      case 'calendar':
        name = `Confirm${
          selectedShifts
            ? selectedShifts.length > 0
              ? ` (${selectedShifts.length})`
              : ''
            : ''
        }`;
        break;
      case 'review':
        name = 'Book';
        break;
      case 'confirmation':
        name = 'Next';
        break;
      case 'complete':
        name = 'Dashboard';
        break;
      default:
        break;
    }
    return name;
  };

  validateFilter = () => {
    const {
      parkinglotId,
      tier,
      shiftStart,
      shiftEnd,
      duration
    } = this.state;
    const invalid = [];
    if (!parkinglotId) {
      invalid.push('parking');
    }
    if (!tier) {
      invalid.push('tier');
    }
    if (!shiftStart) {
      invalid.push('shiftStart');
    }
    if (!shiftEnd) {
      invalid.push('shiftEnd');
    }
    if (duration > 12) {
      invalid.push('duration');
    }
    this.setState({
      invalidFields: invalid
    });
    return (
      parkinglotId && tier && shiftStart && shiftEnd && duration <= 12
    );
  };

  assignButtonAction = () => {
    const { display } = this.state;
    let show;
    switch (display) {
      case 'filter':
      case 'editFilter':
        show = 'calendar';
        break;
      case 'calendar':
        show = 'review';
        break;
      case 'review':
        show = 'confirmation';
        break;
      case 'confirmation':
        show = 'complete';
        break;
      case 'complete':
        show = 'dashboard';
        break;
      default:
        break;
    }
    if (
      (display === 'filter' || display === 'editFilter') &&
      !this.validateFilter()
    ) {
      return null;
    }
    this.setState({ display: show, showModal: false });
  };

  formatHeading = () => {
    const {
      display,
      shiftStart,
      shiftEnd,
      flexible,
      confirmation
    } = this.state;
    switch (display) {
      case 'filter':
      case 'editFilter':
        return 'Booking Preferences';
      case 'calendar':
        return (
          <strong>{`${this.formatShift(shiftStart)}${
            flexible === 'start' ? ' (Flexible)' : ''
          } to ${this.formatShift(shiftEnd)}${
            flexible === 'finish' ? ` (Flexible)` : ''
          }`}</strong>
        );
      case 'review':
        return 'Review Bookings';
      case 'confirmation':
        return 'Booking Summary';
      case 'complete':
        return confirmation.errors.length > 0 &&
          confirmation.bookings.length === 0
          ? 'Error!'
          : 'Success!';
      default:
        break;
    }
  };

  showModal = () => {
    this.setState({ showModal: true });
  };

  pendBooking = pendState => {
    this.setState({ pendingBooking: pendState });
  };

  bookModal = () => (
    <Modal open={this.state.showModal}>
      <div className="book-modal">
        <p>
          Your selected bookings will be discarded once you update the
          booking preferences.
        </p>
        <Button
          color="#414141"
          className="cancel-butt"
          margin="0.5em auto"
          onClick={() => {
            this.setState({ showModal: false });
          }}
          label="Cancel"
        />
        {this.modalAction()}
      </div>
    </Modal>
  );

  modalAction = () => {
    const { display } = this.state;

    return (
      <Button
        onClick={
          display === 'calendar'
            ? () => {
                this.backAction();
                this.setState({ selectedShifts: [] });
              }
            : () => {
                this.assignButtonAction();
                this.setState({ selectedShifts: [] });
              }
        }
        label={display === 'calendar' ? 'Proceed' : 'Update'}
        margin="0.5em auto"
      />
    );
  };

  showUnavailableModal = reason => {
    this.setState({ showUnavailable: true, unavailableMessage: reason });
  };

  unavailableModal = () => (
    <Modal open={this.state.showUnavailable}>
      <div className="unavailable-modal">
        <p>{this.state.unavailableMessage}</p>
        <Button
          color="#414141"
          className="cancel-butt"
          margin="1em 0 0 0"
          onClick={() => {
            this.setState({
              showUnavailable: false,
              unavailableMessage: null
            });
          }}
          label="Close"
        />
      </div>
    </Modal>
  );

  backAction = () => {
    const { flow, display } = this.state;
    let destination;
    switch (display) {
      case 'editFilter':
        destination = 'calendar';
        break;
      case 'confirmation':
      case 'complete':
        destination = 'filter';
        break;
      default:
        destination = flow[flow.indexOf(display) - 1] || 'dashboard';
    }
    this.setState({
      display: destination,
      showModal: false
    });
  };

  formatShift = shiftHour =>
    `${shiftHour % 12}${shiftHour / 12 < 1 ? 'am' : 'pm'}`;

  resetParams = () => {
    this.setState({
      tier: null,
      shiftStart: null,
      shiftEnd: null,
      selectedShifts: []
    });
  };

  receiveConfirmation = confirmation => {
    this.setState({
      confirmation
    });
  };

  renderComplete = () => {
    const { confirmation } = this.state;
    return (
      <div className="book-complete">
        {confirmation.bookings.length > 0 ? (
          <div className="confirm-success">
            <h3 className="text-center">You are all set!</h3>
            <p>
              You will receive a text message 10 minutes before your
              booking begins with all the information you need to pick up
              the car, including the parking lot address, license plate,
              and code to pick up the key.
            </p>
            <Button
              className="previous-button"
              label="Book More"
              onClick={this.backAction}
            />
          </div>
        ) : null}
        {confirmation.errors.length > 0 ? (
          <div className="confirm-error">
            <p>The following selections were unable to be booked:</p>
            {confirmation.errors
              .reduce((arr, e) => {
                if (arr && !arr.find(a => e.startTime === a.startTime)) {
                  arr.push(e);
                }
                return arr;
              }, [])
              .map((error, index) => (
                <div className="confirm-panel" key={index}>
                  <div>
                    <strong>
                      {m(error.startTime).format('MMM Do, YYYY')}
                    </strong>
                    <div>
                      {m(error.startTime).format('h A')} to{' '}
                      {m(error.endTime).format('h A')}
                    </div>
                  </div>
                  <p className="error-message">
                    {error.message.replace(/^schedule\s/gi, '')}
                  </p>
                </div>
              ))}
          </div>
        ) : null}
      </div>
    );
  };

  showPlusInfo = () => {
    this.setState({ showPlusInfo: true });
  };

  plusInfo = () => (
    <Modal open={this.state.showPlusInfo}>
      <div className="plus-info">
        <img src={plusImg} height={114} alt="plus_vehicle" />
        <a
          className="close-plus"
          onClick={() => this.setState({ showPlusInfo: false })}>
          <Icon name="Close" size="sm" />
        </a>
        <p>
          Book an Autzu PLUS from <strong>$4.00/hr</strong> with additional
          benefits
        </p>
        <ul className="modal-list">
          <li>40% off Uber service fee.</li>
          <li>
            0% Uber service fee with $10 bonus for every UberWAV trip.
          </li>
          <li>Free accessibility training worth $250.</li>
        </ul>
        <a href="/plus" target="_blank">
          <Button
            className="modal-button"
            color="#414141"
            onClick={() => {
              this.setState({ showPlusInfo: false });
            }}
            label="Learn More"
          />
        </a>
        <a href="/course" target="_blank">
          <Button
            className="modal-button cancel-butt"
            color="#128dff"
            onClick={() => {
              this.setState({ showPlusInfo: false });
            }}
            label="Start Course"
          />
        </a>
      </div>
    </Modal>
  );

  handleHideOrientation = () => {
    this.setState({ hideOrientation: true });
  };
}

export default MobileBook;



// WEBPACK FOOTER //
// ./src/components/NewBook/MobileIndex.js